import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { BaseService } from 'src/app/shared/base/base.service';
import { DialogService } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';
import { Constants } from 'src/app/app.constants';
import { CustomerOrder, CustomerOrderStatus, CustomerOrderProduct, CustomerOrderCost, CustomerOrderStatusView } from '../customer-orders.models';
import { IdLabel, ValueLabel } from 'src/app/shared/base/base.models';
import { OptionsSource } from 'src/app/core/core.models';
import { PaymentMethodsService } from '../../payment-methods/payment-methods.service';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { MunicipalitiesService } from '../../municipalities/municipalities.service';
import { OfferedProduct } from '../../offered-products/offered-products.models';
import { Product } from '../../products/products.models';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { MeanOfDelivery } from '../../means-of-delivery/means-of-delivery.models';
import { PaymentMethod, PaymentType } from '../../payment-methods/payment-methods-models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { DistributionCalendar } from '../../distribution-calendars/distribution-calendars.models';
import { Municipality } from '../../municipalities/municipalities.models';
import { CostPolicy } from '../../cost-policies/cost-policies.models';
import { GiftPackage } from '../../gift-package/gift-package.models';
import { DxFormComponent, DxSelectBoxComponent } from 'devextreme-angular';
import { User } from '../../users/users.models';
import { TranslateService } from '@ngx-translate/core';
import { Company } from '../../companies/companies.models';
import { CompaniesService } from '../../companies/companies.service';


@Component({
  selector: 'app-customer-orders-form',
  templateUrl: './customer-orders-form.component.html',
  styleUrls: ['./customer-orders-form.component.scss']
})
export class CustomerOrdersFormComponent extends BaseFormComponent implements OnInit {
  @ViewChild('customerOrderProductsList') customerOrderProductsListREF;
  @ViewChild('customerOrderCostsList') customerOrderCostsListREF;
  @ViewChild('customerOrderNotes') customerOrderNotesREF;
  @ViewChild('formDelivery') formDelivery: DxFormComponent;
  @ViewChild('orderStatusSelect') orderStatusSelect: DxSelectBoxComponent;
  // @ViewChild('articlesGrid') articlesGrid: DxDataGridComponent;

  statuses: ValueLabel[] = [];
  distributionCalendarsForDelivery: DistributionCalendar[];
  selectedDistributionCalendars: DistributionCalendar[];
  selectedDistributionCalendar: DistributionCalendar = new DistributionCalendar();
  shippmentTimePeriods: IdLabel[] = [];
  shippmentDate: Date;
  shippmentTimePeriod: string;
  selectedShippingMunicipality: Municipality;

  paymentMethods: OptionsSource;
  meansOfDelivery: OptionsSource;
  municipalities: OptionsSource;
  pointsOfSale: OptionsSource;
  disabledDates: Array<Date> = new Array<Date>();  

  orderStatus: CustomerOrderStatus;
  userType: string;

  tabs = ['PRODUCTS', 'COSTS', 'NOTES', 'DELIVERY_INFO'];
  bucketBaseUrl = Constants.amazonS3Bucket;
  PaymentType = PaymentType;
  allowStatusChange: boolean = true;
  company: Company;

  constructor(
    private companiesService: CompaniesService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService,
    private paymentMethodsService: PaymentMethodsService,
    private meansOfDeliveryService: MeansOfDeliveryService,
    private municipalitiesService: MunicipalitiesService,
    private pointsOfSaleService: PointsOfSaleService,
    private translateService: TranslateService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService);
  }

  async ngOnInit() {
    this.company = await this.companiesService.getCompany(this.authService.companyId);
    this.authorities.init('CD_ORD', 'R_ORD', 'U_ORD', 'CD_ORD');

    this.url = `${Constants.contextPath}/customer-orders`;
    this.prepareLookupData();
    this.prepareFormData(new CustomerOrder(), (response: CustomerOrder) => {
      return this.modifyResponse(response);
    });
  }

  private prepareLookupData() {
    this.statuses = this.utilityService.prepareLookupItemsCustom(this.utilityService.enumToSelectArray(CustomerOrderStatus, true),this.utilityService.enumToSelectArray(CustomerOrderStatusView, true), 'value', 'label', 'ENUMS.CUSTOMER_ORDERS_STATUS.');
    this.paymentMethods = this.paymentMethodsService.getPaymentMethodsLookup();
    this.meansOfDelivery = this.meansOfDeliveryService.getMeansOfDeliveryLookup();
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleLookup();
    this.municipalities = this.municipalitiesService.getMunicipalitiesLookup();
    this.shippmentTimePeriods = [];
  }

  public modifyResponse(response: CustomerOrder) {
    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      //set intial values for expected shippment date
      if(response.shippingMunicipality) {
        this.selectedShippingMunicipality = <Municipality>response.shippingMunicipality;
      }
      this.setSelectedDistributionCalendar((<DistributionCalendar>response.distributionCalendar));
      this.shippmentDate = (<DistributionCalendar>response.distributionCalendar).date;
      this.shippmentTimePeriod = (<DistributionCalendar>response.distributionCalendar).id;
      this.getDistributionCalendarsForDelivery(pointOfSale.id, (<Municipality>response.shippingMunicipality).id, (<MeanOfDelivery>response.meansOfDelivery).id);
    }

    response.breadcrumbsId = response.documentNumber;

    if(response.customerOrderGiftPackage)
       this.tabs.push('GIFT_PACKAGES');
    
    this.orderStatus = response.status;
    
    if(!response.buyer)
      this.userType = this.translateService.instant('ENUMS.USER_TYPES.CLIENT_PUBLIC');
    else
      this.userType = this.translateService.instant('ENUMS.USER_TYPES.' + (<User>response.buyer)?.userType.toString());

    return response;
  }

  private modifyCustomerOrderProducts(customerOrderProducts: CustomerOrderProduct[]): CustomerOrderProduct[] {
    return customerOrderProducts.map(p => (
      {
        product: (<Product>(<OfferedProduct>p.offeredProduct).product).id,
        orderedQuantity: p.orderedQuantity,
        approvedQuantity: p.approvedQuantity,
        deliveredQuantity: p.deliveredQuantity,
        regularPrice: p.regularPrice,
        discountPercentage: p.discountPercentage,
        salePrice: p.salePrice,
        rebatePercentage: p.rebatePercentage,
        invoicePrice: p.invoicePrice
      }
    ))
  }

  private modifyCustomerOrderCosts(costs: CustomerOrderCost[]): CustomerOrderCost[]{
    return costs.map(c => ({ value: c.value, costPolicy: (<CostPolicy>c.costPolicy).id }));
  }

  private modifyCustomerOrderNotes(formData: CustomerOrder, formNotes: any): CustomerOrder {
    formData.internalNote = formNotes.internalNote;
    formData.note = formNotes.note;
    return formData;
  }
  
  private modifyBeforeSave(formData: CustomerOrder) {
    formData.customerOrderProducts = this.modifyCustomerOrderProducts([...this.customerOrderProductsListREF.customerOrderProducts]);

    if(this.selectedDistributionCalendar)
      formData.distributionCalendar = (<DistributionCalendar>this.selectedDistributionCalendar);

    if(formData.distributionCalendar)
      formData.distributionCalendar = (<DistributionCalendar>formData.distributionCalendar).id;

    if(formData.shippingMunicipality)
      formData.shippingMunicipality = (<Municipality>formData.shippingMunicipality).id;

    // customerOrderCostsListREF je != undefined samo ako je korisnik otisao na tab costs
    if(formData.costs || this.customerOrderCostsListREF)
      formData.costs = this.modifyCustomerOrderCosts(this.customerOrderCostsListREF ? this.customerOrderCostsListREF.costs : formData.costs);

    if(this.customerOrderNotesREF)
      formData = this.modifyCustomerOrderNotes(formData, this.customerOrderNotesREF)

    if(formData.pointOfSale)
      formData.pointOfSale = (<PointOfSale>formData.pointOfSale).id;

    if(formData.buyer)
      delete formData.buyer;

    if (formData.meansOfDelivery)
      formData.meansOfDelivery = (<MeanOfDelivery>formData.meansOfDelivery).id;

    if (formData.paymentMethod)
      formData.paymentMethod = (<PaymentMethod>formData.paymentMethod).id;

    if(formData.customerOrderGiftPackage)
      formData.customerOrderGiftPackage = (<GiftPackage>formData.customerOrderGiftPackage).id;

    if(this.selectedShippingMunicipality)
      formData.shippingMunicipality = this.selectedShippingMunicipality.id;

    formData.status = this.orderStatus;      
    return formData;
  }

  public saveChanges(): void {
    if(this.formDelivery != null && this.formDelivery.instance.validate() != null && !this.formDelivery.instance.validate().isValid){
        this.alertService.error('SHARED.INVALID_FORM');
        return;
    }

    if (!this.isFormValid())
      return;

    let data = this.modifyBeforeSave({...this.formData})

    if (this.id == null)
      this.baseService.create(this.url, data, () => {
        this.onSaveSuccess();
      });
    else
      this.baseService.update(this.url, data, () => {
        this.onSaveSuccess();
      });
  }

  private getDistributionCalendarsForDelivery(pointOfSale: string, deliveryZone?: string, meansOfDelivery?: string){
        let distributionCalendarsForDelivery: DistributionCalendar = new DistributionCalendar();
        
        distributionCalendarsForDelivery.meansOfDelivery = meansOfDelivery;
        distributionCalendarsForDelivery.deliveryZone = deliveryZone;
        distributionCalendarsForDelivery.pointOfSale = pointOfSale;
        // this.customerOrdersService.getDistributionCalendarForOrder(distributionCalendarsForDelivery, (res: DistributionCalendar[])=> {
        this.distributionCalendarsForDelivery = [];
        this.setTimeOptionsForCalendar(null);
        // })
  }

  setSelectedDistributionCalendar(dc: DistributionCalendar = new DistributionCalendar()){
    this.selectedDistributionCalendar = dc;
    this.shippmentDate = dc.date ? dc.date : null;
  }

   findSelectedDistributionCalendar(id:string): DistributionCalendar {
    for(var d of <DistributionCalendar[]>this.distributionCalendarsForDelivery) {     
      if(d.id.toString() == id.toString())
          return d;
    }
    return null;
  }

  private setTimeOptionsForCalendar(selectedDate?: Date){
    this.selectedDistributionCalendars = new Array<DistributionCalendar>();

    if(selectedDate!=null)
      this.shippmentDate = selectedDate;

    

    for (let calendar of this.distributionCalendarsForDelivery){
         if(new Date(calendar.date).toDateString() == new Date(this.shippmentDate).toDateString()){
             this.selectedDistributionCalendars.unshift(calendar);
         }
         this.disabledDates.unshift(new Date(calendar.date));
    }
    this.selectedDistributionCalendars.sort((a,b)=> {
         var dateA = a.timeFrom;
         var dateB = b.timeFrom;
         return dateA > dateB ? 1 : -1;
    });​
    this.shippmentTimePeriods = [];
    if(this.shippmentDate == (<DistributionCalendar>this.selectedDistributionCalendar).date)
        this.shippmentTimePeriods.push(new IdLabel((<DistributionCalendar>this.selectedDistributionCalendar).id,this.utilityService.formatTime((<DistributionCalendar>this.selectedDistributionCalendar).timeFrom.toString()) + " - " + this.utilityService.formatTime((<DistributionCalendar>this.selectedDistributionCalendar).timeTo.toString())));
    
    this.selectedDistributionCalendars.forEach(element => {
      this.shippmentTimePeriods.push(new IdLabel(element.id,this.utilityService.formatTime(element.timeFrom.toString()) + " - " + this.utilityService.formatTime(element.timeTo.toString())));
    });
  }

  public onDateChanged = (event) => {
    if(this.distributionCalendarsForDelivery != null){
      this.setTimeOptionsForCalendar(event.value);
    }
  }

  public onTimePeriodChanged = (event) => {
    // if(this.distributionCalendarsForDelivery != null) {
    //   this.setSelectedDistributionCalendar(this.findSelectedDistributionCalendar(event.value));

    //   this.pendingChanges = true;
    // }
  }

  public onPaymentMethodChanged = (event) => {    
    if(event.previousValue && event.previousValue.type == PaymentType[PaymentType.ON_LINE] && event.value.type != PaymentType[PaymentType.ON_LINE]) {
      this.formData.status = CustomerOrderStatus[CustomerOrderStatus.SUBMITTED];
      this.orderStatus = <null>CustomerOrderStatus[CustomerOrderStatus.SUBMITTED].replace(/""/g, '');
      this.alertService.success('CUSTOMER_ORDERS.STATUS_TO_SUBMITTED', 10000);
      this.allowStatusChange = false;
    }
  }

  public onInitialized = (event) => {
  
    let self = this;
    event.component.option("calendarOptions", 
    { 
      cellTemplate : function (itemData, itemIndex, itemElement) {
        var myCustomMarkup = "";
        if (self.disabledDates.findIndex(x => new Date(x).toDateString() == new Date(itemData.date).toDateString()) > -1)
            myCustomMarkup = "<div style='color: red'>" + itemData.text + "</div>"
        else
            myCustomMarkup = itemData.text;
        
        return myCustomMarkup; 
      }
    });
  }

  shippingMunicipalityChanged = (event) => {
    this.selectedShippingMunicipality = event.selectedItem;
  }

  updateCosts(event){
    (<CustomerOrder>this.formData).regularValue = 0;
    (<CustomerOrder>this.formData).saleValue = 0;
    (<CustomerOrder>this.formData).invoiceValue = 0;
    (<CustomerOrder>this.formData).totalValue = 0;

    let allCosts = 0;
    this.formData?.costs?.forEach(c => {
      allCosts+=c.costPolicy.value;
    });
    this.customerOrderProductsListREF.customerOrderProducts.forEach(e => {
      (<CustomerOrder>this.formData).regularValue += e.approvedQuantity*e.regularPrice; 
      (<CustomerOrder>this.formData).saleValue += e.approvedQuantity*e.salePrice; 
      (<CustomerOrder>this.formData).invoiceValue += e.approvedQuantity*e.invoicePrice; 
      (<CustomerOrder>this.formData).totalValue += e.approvedQuantity*e.regularPrice;      
    });
    (<CustomerOrder>this.formData).totalValue += allCosts;
  }

}